import ApiHttpClient from "lib/api-http-client";

class BackendGateway {
  #apiClient;

  constructor(apiClient) {
    this.#apiClient = apiClient;
  }

  fetchCurrentUserPermissions(userParams) {


    // throw new Error(" missing from the arguments.");

    // return require("../../dummy-data/audioPlayerDummy.json");

    // return this.#apiClient.get(
    //   "https://stage-media.spotlight-verlag.de/issue/spotlight/printproduct/plus/202007/0/0/data?_format=json"
    // );

    const promise = new Promise((resolve, _) => {
      //const data = require("../../dummy-data/Dummy.json");
      //resolve(data);

      if (userParams.token == 0) {
         const tmp = document.getElementById('root').getAttribute('tok');
        if (tmp.length > 0) userParams.token = tmp;      
      }
      
      const host = window.location.protocol + "//" + window.location.host;
      const params = [
        window.location.origin.includes("localhost") ? 'http://zsarchive.local.de' : host,
        'issue',
        userParams.brand,
        userParams.variant,
        userParams.issue,
        userParams.uuid ? userParams.uuid : 0,
        userParams.token ? userParams.token : 0,
        'data?_format=json'
      ];

      let fetchUrl = params.join('/');
      //console.log(fetchUrl);
      const data = this.#apiClient.get(fetchUrl)
        .then(resp => {
          resolve(resp.data);
      });      
    });

    return promise;
  }
}

export default new BackendGateway(ApiHttpClient);
